export default {
  memberReferral: '友達紹介',
  'memberReferral.title': '友達と一緒に報酬をゲット',
  'memberReferral.description':
    '友達に登録時紹介コードを入力してもらうか、<br />紹介リンクから登録してください',
  'memberReferral.code': '紹介コード',
  'memberReferral.url': '紹介リンク',
  'memberReferral.copy.success': 'コピー成功！',
  'memberReferral.message.disabled': '現在はキャンペーン期間外です！',
  'memberReferral.message.title': '{name} に一緒に参加しよう',
  'memberReferral.message.description':
    '友達紹介コード：{code} を登録時に入力するか、紹介リンクから登録してください',
  'memberReferral.message.join': '会員登録する',
  'memberReferral.message.share': 'シェアする',
  'memberReferral.message.success': '紹介リンクの共有に成功しました！',
  'memberReferral.message.version':
    'LINEのバージョンが古すぎます。アップデートしてから再試行してください',
  'memberReferral.message.fail': '共有に失敗しました。しばらくしてからもう一度お試しください',
} as Record<string, string>;
